<template>
    <div class="card-body">
        <div class="card-body">
            <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="direccion in addresses">
                    <b-form-radio v-model="selected" name="adress">
                    <address class="d-flex w-100 justify-content-between text-capitalize">
                        <p>{{ direccion.street }} {{ direccion.no_ext }}{{ direccion.suburb }}, {{ direccion.state }}, {{ direccion.cp }},
                            {{ direccion.btw_streets }}, {{ direccion.references }}</p>
                    </address>
                    </b-form-radio>
                </li>
            </ul>			
        </div>
</div>


</template>

<script>
import DirectionRow from '@/components/DirectionRow.vue'
import axios from "axios";

export default {
name: "Directions",
    components: {
        DirectionRow
    },

    props: {
        direcciones: {
            type: Array
        }

    },

    data(){
        return{
            url: this.api_url+'/direcciones',
            direcciones: []
        };
    },
	methods: {
		getDirections(){
			axios.get(this.url).then(data=>{
			this.direcciones = data.data;

			});
        },
        
        created() {
            this.getDirections();
        },
        onEdit(data){
             //window.console.log("directions list edit" + data);
            //this.$emit("onEdit", this.directions.subscriber_id);
            this.$emit("onEdit", data);
    
        }
	}
}

</script>

<style lang="scss">
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.modal-content {
    border-radius: 0 none;
    -moz-border-radius: 0 none;
    -webkit-border-radius: 0 none;
}

.site-footer {
    //background-image: url(images/backfooter.png); idk why doesn't aply 
    background-color: #000000;
    color: #fff !important;
}

.site-footer a {
    color: #fff;
    text-decoration: none;
}

.site-footer .footer-heading {
    color: #fff;
}

.site-footer .address,
.site-footer .email,
.site-footer .phone {
    color: #fff;
}

.site-footer .phone a {
    color: #fff;
    text-decoration: none;
}
</style>